export default __webpack_public_path__ + "static/media/see.0c35e51b.svg";